import { TThunkAction } from '../../types/redux';
import { sendTelemetryCounter } from '../../services/telemetry';
import { MCS_NAME } from '../../constants/mcsName';
import { getTrackingBankiruUri } from './utils/getTrackingBankiruUri';

export const fetchTrackingBankiru = (advSub: number, transactionId: string): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      await httpApi.httpRequest({
        uri: getTrackingBankiruUri(advSub, transactionId),
        withCredentials: false,
      });
    } catch (err) {
      logger.warning(err, {
        domain: 'fetchTrackingBankiru.ts',
      });
      sendTelemetryCounter({
        httpApi,
        key: `${MCS_NAME}.fetch-tracking-bankiru-error`,
      });
    }
  };
};
